var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 942,
    viewBox: "0 0 1440 942",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3997_5934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-69.5004 592.5C-73.667 487.833 -18.7004 278.2 234.5 277C551 275.5 720.5 528.5 688.5 706C656.5 883.5 358 803.5 482.5 579.5C582.1 400.3 1313 -1.5 1666 -180",
    stroke: "#2F4077",
    strokeOpacity: 0.06,
    strokeWidth: 140
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3997_5934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 942,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.7da5cd67a98349c99b8a042df896d1f5.svg";
export { ForwardRef as ReactComponent };